import {useLocation} from '@github-ui/react-router'
import {useContext} from 'react'

import {RouteStateMapContext} from './route-state-map-context'

export function useCurrentRouteState<T>() {
  const routeStateMap = useContext(RouteStateMapContext)
  const location = useLocation()

  return routeStateMap[location.key] as T
}
